import { useState, useEffect, useRef } from "react";
import { Input } from "@/components/ui/input";

const toStr = (value) =>
  value === null || value === undefined || value === "" ? "" : String(value).replace(".", ",");

export function DecimalInput({ value, onValueChange, ...props }) {
  const [str, setStr] = useState(() => toStr(value));
  const focused = useRef(false);

  useEffect(() => {
    if (!focused.current) setStr(toStr(value));
  }, [value]);

  const handle = (e) => {
    let v = e.target.value.replace(/[^0-9.,]/g, "");
    const firstComma = v.indexOf(",");
    if (firstComma !== -1) {
      v = v.slice(0, firstComma + 1) + v.slice(firstComma + 1).replace(/[.,]/g, "");
    }
    setStr(v);
    if (v === "" || v === "," || v === ".") { onValueChange(0); return; }
    const num = parseFloat(v.replace(",", "."));
    onValueChange(isNaN(num) ? 0 : num);
  };

  return (
    <Input
      type="text"
      inputMode="decimal"
      {...props}
      value={str}
      onFocus={() => { focused.current = true; }}
      onBlur={() => { focused.current = false; setStr(toStr(value)); }}
      onChange={handle}
    />
  );
}
